// extracted by mini-css-extract-plugin
export var attachment = "_rd-a";
export var emailContainer = "_rd-4";
export var emailContentPaddedContainer = "_rd-b";
export var emailHeader = "_rd-6";
export var emailIframe = "_rd-3";
export var emailInfoIcon = "_rd-9";
export var emailShortenedSummary = "_rd-e";
export var infoDropdown = "_rd-0";
export var infoRowBoundedContent = "_rd-d";
export var internal = "_rd-5";
export var merchant = "_rd-8";
export var messageInputContainer = "_rd-h";
export var normal = "_rd-7";
export var replyCard = "_rd-f";
export var subtleButton = "_rd-1";
export var subtleButtonIconContainer = "_rd-2";
export var toggleViewRepliesButton = "_rd-c";
export var wrappingText = "_rd-g";